import { FC } from "react";
import { View, StyleSheet } from "@react-pdf/renderer";

import { SummaryBox } from "../../common/SummaryBox";

type Amount = {
  currency: string;
  value: number;
};

type Props = {
  sent: Amount;
  exchangeRate: Amount;
  endOfTheYear: Amount;
  receiveNow: Amount;
};

const styles = StyleSheet.create({
  wrapper: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-start",
    width: "100%",
    paddingTop: "16",
  },
});

export const SummarySection: FC<Props> = ({
  sent,
  exchangeRate,
  endOfTheYear,
  receiveNow,
}) => {
  return (
    <View style={styles.wrapper}>
      <SummaryBox label="Sent" currency={sent.currency} amount={sent.value} />

      <SummaryBox
        label="Exchange rate"
        currency={exchangeRate.currency}
        amount={exchangeRate.value}
      />

      <SummaryBox
        label="Get at the end of the year (TDS)"
        currency={endOfTheYear.currency}
        amount={endOfTheYear.value}
      />

      <SummaryBox
        label="Receive now"
        currency={receiveNow.currency}
        amount={receiveNow.value}
      />
    </View>
  );
};
